<template>
  <option :value="item.code" :selected="isSelected">
    {{ title }}
  </option>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },

    selectedVariation: {
      type: Object,
      required: true,
    },
  },

  computed: {
    title() {
      return [this.item.color_title, this.item.size_title]
        .filter(Boolean)
        .join(' / ');
    },

    isSelected() {
      return this.selectedVariation.code === this.item.code;
    },
  },
};
</script>
